export const isMobile = () => {
    return window.innerWidth < 768;
}

export const getDeviceType = () => {
    return isMobile() ? "mobile" : "desktop";
}

export const getScreenWidth = () => {
    return window.innerWidth;
}